export default __webpack_public_path__ + "static/ShiseidoGinza-c0a413e442a2c274f42f8403d0205850.woff";